import { faListMusic } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation } from "react-router-dom";
import {
  NAV_BUTTON_VARIANT,
  NavButton,
} from "../NavigationRow/components/NavButton/NavButton";
import { getNavButtonColor } from "../utils";
import { ROUTE_PREFIXES } from "../../../../routes";

interface MyMusicMenuProps {
  showIconOnly?: boolean;
}

export const MyMusicMenu = ({ showIconOnly = false }: MyMusicMenuProps) => {
  const { pathname } = useLocation();

  return (
    <NavButton
      variant={NAV_BUTTON_VARIANT.LINK}
      frontIcon={
        <FontAwesomeIcon
          color={getNavButtonColor([ROUTE_PREFIXES.MY_MUSIC], pathname)}
          icon={faListMusic}
          size="xl"
        />
      }
      message="Music"
      path={ROUTE_PREFIXES.MY_MUSIC}
      showIconOnly={showIconOnly}
      color={getNavButtonColor([ROUTE_PREFIXES.MY_MUSIC], pathname)}
    />
  );
};
